/* eslint-disable no-underscore-dangle */
export const PRODUCTION = 'production';
export const DEVELOPMENT = 'development';

window._env_ = { ...import.meta.env, ...window._env_ };

// TODO: Add zod validation
export const ENV = {
  NODE_ENV: process.env.NODE_ENV,
  VITE_API_URL: window._env_.VITE_API_URL,
  VITE_API_URL_IMAGES: window._env_.VITE_API_URL_IMAGES,
  VITE_ENVIRONMENT: window._env_.VITE_ENVIRONMENT,
  VITE_WEBSOCKET_URL: window._env_.VITE_WEBSOCKET_URL,
  VITE_GOOGLE_CLIENT_ID: window._env_.VITE_GOOGLE_CLIENT_ID,
  VITE_FIREBASE_API_KEY: window._env_.VITE_FIREBASE_API_KEY,
  VITE_FIREBASE_AUTH_DOMAIN: window._env_.VITE_FIREBASE_AUTH_DOMAIN,
  VITE_FIREBASE_PROJECT_ID: window._env_.VITE_FIREBASE_PROJECT_ID,
  VITE_FIREBASE_STORAGE_BUCKET: window._env_.VITE_FIREBASE_STORAGE_BUCKET,
  VITE_FIREBASE_MESSAGING_SENDER_ID: window._env_.VITE_FIREBASE_MESSAGING_SENDER_ID,
  VITE_FIREBASE_APP_ID: window._env_.VITE_FIREBASE_APP_ID,
  VITE_FIREBASE_MEASUREMENT_ID: window._env_.VITE_FIREBASE_MEASUREMENT_ID,
  VITE_FIREBASE_VAPID_KEY: window._env_.VITE_FIREBASE_VAPID_KEY,
  VITE_KEYCLOAK_CLIENT_ID: window._env_.VITE_KEYCLOAK_CLIENT_ID,
  VITE_KEYCLOAK_BASE_URL: window._env_.VITE_KEYCLOAK_BASE_URL,
  VITE_KEYCLOAK_REALM: window._env_.VITE_KEYCLOAK_REALM,
  VITE_SENTRY_DSN: window._env_.VITE_SENTRY_DSN,
  VITE_MICROSOFT_CLARITY_APP_KEY: window._env_.VITE_MICROSOFT_CLARITY_APP_KEY,
  VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID: window._env_.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID,
  VITE_GOOGLE_TAG_MANAGER_ID: window._env_.VITE_GOOGLE_TAG_MANAGER_ID,
  VITE_ITAR_ENVIRONMENT: window._env_.VITE_ITAR_ENVIRONMENT || '1',
  VITE_YBUG_ID: window._env_.VITE_YBUG_ID,
} as const;

export const isITAREnvironment = () => ENV.VITE_ITAR_ENVIRONMENT === '1';
